export class Ddapi {

    //钉钉签名设置
    config(cfg) {
        DingTalkPC.config(cfg);
    }

    //钉钉容器设置
    // ready() {
    //     return new Promise(function (resolve) {
    //         DingTalkPC.ready(function () {
    //             resolve();
    //         });
    //     })
    // }

    //免登er
    requestAuthCode(corpid) {
        return new Promise(function (resolve) {
            DingTalkPC.runtime.permission.requestAuthCode({
                corpId: corpid, //企业ID
                onSuccess: function (result) {
                    resolve(result.code)

                },
                onFail: function (err) {
                    console.log(1)
                }
            })
        })
    }


    error(){
        return new Promise(function(resolve){
            DingTalkPC.error(function(error){
                resolve(error)
            })
        })
    }
    toast(text, icon = '', duration = 2, delay = 0) {
        DingTalkPC.device.notification.toast({
            type: icon, //toast的类型 alert, success, error, warning, information, confirm
            text: text, //提示信息
            duration: duration, //显示持续时间，单位秒，最短2秒，最长5秒
            delay: 0, //延迟显示，单位秒，默认0, 最大限制为10
            onSuccess : function(result) {
                /*{}*/
            },
            onFail : function(err) {}
        })
  }
  //  scrollLoad() {
  //       return new Promise(function (resolve) {
  //           document.getElementById("CloudBody").onscroll = function () {
  //               if (this.scrollTop < 2) {
  //                   resolve(0)
  //               }
  //               if (this.scrollTop > 2) {
  //                   dd.ui.pullToRefresh.disable()
  //               }
  //               if (this.scrollHeight - this.scrollTop - this.offsetHeight < 2) {
  //                   resolve(1)
  //               }
  //           }
  //       })
  //   }
}

let ddapi = new Ddapi();
export default ddapi;



// WEBPACK FOOTER //
// ./src/auth/ddapi.js